export default __webpack_public_path__ + "static/media/beer.45a4eeb0.jpg";